import $ from 'jquery';

// this is our central hub
export const $hub = $({});

// define all the events which can be gobally broadcasted
export const event = {
    addToCart: 'cart.add',
    shoppingCartUpdate: 'cart.update',
    storeSelected: 'store.selected',
    spinnerShow: 'spinner.show',
    spinnerHide: 'spinner.hide',
    quantityUpdated: 'quantity.updated'
};

/* create 2 functions (for broadcasting and subscribing to events defined here) */

// publish
export const publish = function (subscribeEvent, data) {
    $hub.trigger(subscribeEvent, [data]);
};

// subscribe
export const subscribe = function (subscribeEvent, callback) {
    $hub.on(subscribeEvent, function (e, data = null) {
        callback(e, data);
    });
};

export const subscribeOnce = function(subscribeEvent, callback) {
    $hub.one(subscribeEvent, function (e, data = null) {
        callback(e, data);
    });
};

export default {
    $hub,
    event,
    publish,
    subscribe,
    subscribeOnce
};
